// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__3OJ-P","form":"styles_form__TbMP1"};